
import { defineComponent, nextTick, onMounted, ref, watch } from 'vue';
import useWallet from '@/composables/wallet';
import useCluster from '@/composables/cluster';
import { initGemFarm } from '@/common/gem-farm';
import { PublicKey } from '@solana/web3.js';
import ConfigPane from '@/components/ConfigPane.vue';
import FarmerDisplay from '@/components/gem-farm/FarmerDisplay.vue';
import Vault from '@/components/gem-bank/Vault.vue';
import { INFT } from '@/common/web3/NFTget';
import { findFarmerPDA, stringifyPKsAndBNs } from '@gemworks/gem-farm-ts';
import { parseDate } from '@/common/util';
import NFTStaked from '@/components/gem-bank/NFTStaked.vue';
import Button from '@/components/Button.vue'
import Loading from '@/components/Loading.vue';

export default defineComponent({
  components: { Vault, FarmerDisplay, ConfigPane, NFTStaked, Button, Loading },
  setup() {
    const { wallet, getWallet } = useWallet();
    const { cluster, getConnection } = useCluster();
    const openPopup = ref(false);
    const notStakeAccount = ref(false);
    const loading = ref(false)
    const loadingAdd = ref(false)
    const claimLoad = ref(false)
    const loadingText = ref('')
    const innerWidthx = ref(0)

    let gf: any;
    watch([wallet, cluster], async () => {
      await freshStart();
    });

    //needed in case we switch in from another window
    onMounted(async () => {
      console.log('window.innerWidth')
      console.log(window.innerWidth)
      console.log('window.innerWidth')
      innerWidthx.value = window.innerWidth
      await freshStart();
    });

    // --------------------------------------- farmer details
    const farm = ref<string>('E7Vtt9aTKB8QQiod7563aXQXRvfMLdsLaxdaj9Q7RD72');
    const farmAcc = ref<any>();

    const farmerIdentity = ref<string>();
    const farmerAcc = ref<any>();
    const farmerState = ref<string>();
    const availableA = ref<string>();
    const availableB = ref<string>();

    //auto loading for when farm changes
    watch(farm, async () => {
      await freshStart();
    });

    const updateAvailableRewards = async () => {
      availableA.value = farmerAcc.value.rewardA.accruedReward
        .sub(farmerAcc.value.rewardA.paidOutReward)
        .toString();
      availableB.value = farmerAcc.value.rewardB.accruedReward
        .sub(farmerAcc.value.rewardB.paidOutReward)
        .toString();
    };

    const fetchFarn = async () => {
      farmAcc.value = await gf.fetchFarmAcc(new PublicKey(farm.value!));
      console.log(
        `farm found at ${farm.value}:`,
        stringifyPKsAndBNs(farmAcc.value)
      );
    };

    const fetchFarmer = async () => {
      console.log('pasooooo por aqui el cambiar el valor de farmer state <=================')
      const [farmerPDA] = await findFarmerPDA(
        new PublicKey(farm.value!),
        getWallet()!.publicKey!
      );
      farmerIdentity.value = await getWallet()!.publicKey?.toBase58();
      farmerAcc.value = await gf.fetchFarmerAcc(farmerPDA);
      farmerState.value = await gf.parseFarmerState(farmerAcc.value);
      await updateAvailableRewards();
      console.log(
        `farmer found at ${farmerIdentity.value}:`,
        stringifyPKsAndBNs(farmerAcc.value)
      );
    };

    const freshStart = async () => {
      if (getWallet() && getConnection()) {
        gf = await initGemFarm(getConnection(), getWallet()!);
        farmerIdentity.value = await getWallet()!.publicKey?.toBase58();

        //reset stuff
        farmAcc.value = undefined;
        farmerAcc.value = undefined;
        farmerState.value = undefined;
        availableA.value = undefined;
        availableB.value = undefined;

        try {
          await fetchFarn();
          await fetchFarmer();
        } catch (e) {
          notStakeAccount.value = true
          console.log(`farm with PK ${farm.value} not found :(`);
        }
      }
    };

    const initFarmer = async () => {
      loading.value = true
      try {
        await gf.initFarmerWallet(new PublicKey(farm.value!));
        fetchFarmer();
        loading.value = false
      } catch {
        loading.value = false
      }
    };

    const start = async () => {
      loading.value = true
      loadingText.value = 'Sending the Platypus to the Staking Platform'
      try {
        await gf.stakeWallet(new PublicKey(farm.value!));
        await fetchFarmer();
        selectedNFTs.value = [];
        loading.value = false
        loadingText.value = ''
      } catch (err) {
        loading.value = false
        loadingText.value = ''
      }
    }

    // --------------------------------------- staking
    const beginStaking = async () => {
      // await gf.stakeWallet(new PublicKey(farm.value!));
      await fetchFarmer();
      selectedNFTs.value = [];
    };

    const endStaking = async () => {
      loading.value = true
      loadingText.value = 'Unstaking the Platypus and sending it to the Bank'
      try {
        await gf.unstakeWallet(new PublicKey(farm.value!));
        await fetchFarmer();
        await freshStart();
        selectedNFTs.value = [];
        loading.value = false
        loadingText.value = ''
      } catch (err) {
        loading.value = false
        loadingText.value = ''
      }
    };

    const claim = async () => {
      console.log(farmAcc.value.rewardA.rewardMint)
      claimLoad.value = true
      try {
        await gf.claimWallet(
          new PublicKey(farm.value!),
          new PublicKey(farmAcc.value.rewardA.rewardMint!),
          new PublicKey(farmAcc.value.rewardB.rewardMint!)
        );
        fetchFarmer();
        claimLoad.value = false
      } catch (err) {
        claimLoad.value = false
      }
    };

    const handleRefreshFarmer = async () => {
      await fetchFarmer();
    };

    const handleSelectedWallet = () => {
      console.log('change wallet selected')
    }

    // --------------------------------------- adding extra gem
    const selectedNFTs = ref<INFT[]>([]);

    const handleNewSelectedNFT = (newSelectedNFTs: INFT[]) => {
      console.log(`selected ${newSelectedNFTs.length} NFTs`);
      selectedNFTs.value = newSelectedNFTs;
    };

    const addSingleGem = async (
      gemMint: PublicKey,
      gemSource: PublicKey,
      creator: PublicKey
    ) => {
      try {
        await gf.flashDepositWallet(
          new PublicKey(farm.value!),
          '1',
          gemMint,
          gemSource,
          creator
        );
        await fetchFarmer();
        loading.value = false
        loadingText.value = ''
      } catch {
        loading.value = false
        loadingText.value = ''
      }
    };

    const addGems = async () => {
      console.log('paso por aqui de antes de loading....')
      loading.value = true
      loadingText.value = 'Sending the Platypus to the Staking Platform'
      await Promise.all(
        selectedNFTs.value.map((nft) => {
          const creator = new PublicKey(
            //todo currently simply taking the 1st creator
            (nft.onchainMetadata as any).data.creators[0].address
          );
          console.log('creator is', creator.toBase58());

          addSingleGem(nft.mint, nft.pubkey!, creator);
        })
      )
      console.log(
        `added another ${selectedNFTs.value.length} gems into staking vault`
      );
    };

    function financial(x: any) {
      return Number.parseFloat(x).toFixed(2);
    }

    const getDecimals = (val: any) => {
      // const CFORMAT_BTC = Intl.NumberFormat('de-DE', { style: 'currency', currency: 'XBT' })
      console.log('paso por decimales')
      console.log(val)
      const newVal: string = financial(val / 1000000000)
      console.log(newVal)
      console.log('paso por decimales')
      return newVal;
    }

    return {
      wallet,
      farm,
      notStakeAccount,
      farmAcc,
      farmer: farmerIdentity,
      farmerAcc,
      farmerState,
      availableA,
      availableB,
      initFarmer,
      beginStaking,
      endStaking,
      claim,
      handleRefreshFarmer,
      selectedNFTs,
      handleNewSelectedNFT,
      addGems,
      parseDate,
      NFTStaked,
      openPopup,
      getDecimals,
      handleSelectedWallet,
      start,
      loading,
      claimLoad,
      loadingAdd,
      loadingText,
      innerWidthx
    };
  },
});
